import { createBrowserRouter, type RouteObject } from 'react-router';

import { RequireSignIn } from '@/auth/AuthProvider';
import { LoginCallback } from '@/auth/LoginCallback';
import { CALLBACK_PATH } from '@/auth/settings';
import { ComponentsPage } from '@/features/components/ComponentsPage';
import { ConfigEditPage } from '@/features/config/ConfigEditPage';
import { ConfigHistoryPage } from '@/features/config/ConfigHistoryPage';
import { ConfigListPage } from '@/features/config/ConfigListPage';
import { IncidentsPage } from '@/features/incidents/IncidentsPage';
import { OverviewPage } from '@/features/overview/OverviewPage';
import { ProposalPage } from '@/features/proposals/ProposalPage';
import { QueuePage } from '@/features/queue/QueuePage';
import { RunHistoryPage } from '@/features/runs/RunHistoryPage';

import { NotFoundPage, RouteErrorPage } from './errors';
import { ScopeLayout } from './ScopeLayout';
import { Shell } from './Shell';

/**
 * The console behind sign-in (CHG-050). The callback sits outside the shell and the gate: it is
 * where a visitor who is not signed in yet lands.
 */
export const routes: RouteObject[] = [
  { path: CALLBACK_PATH, element: <LoginCallback />, errorElement: <RouteErrorPage /> },
  {
    path: '/',
    element: (
      <RequireSignIn>
        <Shell />
      </RequireSignIn>
    ),
    errorElement: <RouteErrorPage />,
    children: [
      { index: true, element: <OverviewPage /> },
      {
        path: 'scopes/:scope',
        element: <ScopeLayout />,
        children: [
          { index: true, element: <ComponentsPage /> },
          { path: 'queue', element: <QueuePage /> },
          { path: 'incidents', element: <IncidentsPage /> },
          { path: 'components/:capabilityId/runs', element: <RunHistoryPage /> },
          { path: 'config', element: <ConfigListPage /> },
          { path: 'config/:capabilityId', element: <ConfigEditPage /> },
          { path: 'config/:capabilityId/history', element: <ConfigHistoryPage /> },
        ],
      },
      { path: 'proposals/:proposalId', element: <ProposalPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
];

export function createRouter() {
  return createBrowserRouter(routes);
}
